import {Component, OnInit} from '@angular/core';
import {ApiService, ChatbotRagContextResult, PagedResult, PayloadBag} from "../../../services/api.service";
import {ActivatedRoute, Params, Router, RouterLink} from "@angular/router";
import {Observable} from "rxjs";
import {JsonPipe, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from "@angular/common";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {MatTabsModule} from "@angular/material/tabs";
import {DataPreviewComponent} from "../../../core/data-preview/data-preview.component";
import {MatCardModule} from "@angular/material/card";
import {DataTableComponent} from "../../../core/data-table/data-table.component";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'app-chatbot-context-var',
  standalone: true,
  imports: [
    NgIf,
    LoaderContainerComponent,
    MatTabsModule,
    NgForOf,
    JsonPipe,
    DataPreviewComponent,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    MatCardModule,
    NgClass,
    DataTableComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    ActionsContainerComponent,
    MatButtonModule,
    MatProgressBarModule,
    RouteContainerComponent,
    RouterLink,
    MatTooltipModule
  ],
  templateUrl: './chatbot-context-var.component.html'
})
export class ChatbotContextVarComponent implements OnInit {

  readonly tabs = ['Search', 'Data', 'Schema']
  activeTab: string = 'Schema'
  chatbotUuid?: string
  contextVar?: string
  loader?: Observable<ChatbotRagContextResult>
  result?: ChatbotRagContextResult
  searchForm: FormGroup
  searchResults?: any[]
  schemaFieldToIndexMap: {[id: string]: any} = {}

  varDataLoader?: Observable<PagedResult<any>>
  varDataPaged?: PagedResult<any>
  loading = false
  error: any

  constructor(
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly api: ApiService,
    readonly fb: FormBuilder) {
    this.searchForm = this.fb.group({
      prompt: ['']
    })
  }

  searchInContext() {
    if (this.searchForm.valid) {
      const prompt: string = this.searchForm.value['prompt']
      this.api.postChatbotContextVarSearch(this.chatbotUuid!, this.contextVar!, prompt).subscribe({
        next: (r) => {
          this.searchResults = r
        }
      })
    }
  }

  setActiveMainTab(tab: string) {
    this.activeTab = tab
    const queryParams: Params = { tab  };
    this.router.navigate(
      ['.'],
      {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      }
    ).finally(() => {
    })
  }

  ngOnInit(): void {
    this.chatbotUuid = this.route.snapshot.params['chatbotUuid']
    this.contextVar = this.route.snapshot.params['contextVar']
    const tabFromQuery = this.route.snapshot.queryParams['tab']
    this.activeTab = tabFromQuery && this.tabs.includes(tabFromQuery) ? tabFromQuery : this.tabs[1]
    this.loader = this.api.getChatbotContextVarInfo(this.chatbotUuid!, this.contextVar!)
    this.filterData()
  }

  filterDataNext() {
    if (this.varDataPaged && this.varDataPaged.pageIndex < (this.varDataPaged.totalPages - 1)) {
      this.filterData(this.varDataPaged.pageIndex + 1)
    }
  }

  filterDataPrevious() {
    if (this.varDataPaged && this.varDataPaged.pageIndex > 0) {
      this.filterData(this.varDataPaged.pageIndex - 1)
    }
  }

  filterData(pageIndex: number = 0) {
    this.varDataLoader = this.api.getChatbotContextData(this.chatbotUuid!, this.contextVar!, pageIndex)
  }

  onLoadPagedData(result: PagedResult<any>) {
    this.varDataPaged = result
    this.loading = false
  }

  onLoad(result: ChatbotRagContextResult) {
    this.result = result
    this.loading = false

    if (result.info && result.info.schemaDef) {
      const indexes = Object.getOwnPropertyNames(result.info.indexes)
        .map((indexName: string) => result.info!.indexes[indexName])
      console.warn(indexes)
      const fieldNames: string[] = result.info.schemaDef['fields'].map((f: any) => f['name'])
      console.warn(fieldNames)
      const fieldIndexes: {[id: string]: any} = {}
      fieldNames.forEach(fName => {
        fieldIndexes[fName] = indexes.filter((idx: any) =>  idx['field_name'] == fName)
      })
      this.schemaFieldToIndexMap = fieldIndexes
    }
    else {
      this.schemaFieldToIndexMap = {}
    }
  }

  deleteItem(itemId: string) {
    this.loading = true
    this.error = undefined
    this.api.deleteChatbotContextVarEntry(this.chatbotUuid!, this.contextVar!, itemId).subscribe({
      next: () => {
        this.filterData(this.varDataPaged?.pageIndex || 0)
      },
      error: (e) => {
        this.error = e
        this.loading = false
        console.error(e)
      }
    })
  }
}
